export class GetSFTPLogsBo  {
    startDate: string;
    endDate: string;
    authDetailImportStatus: string = null;
    recipientName: string;
    currentpageno: number = 1;
    pageitem: number = 10;
    orderColumn: string="recipientName";
    field: string = "recipientName";
    orderType: string = "asc";
    type: string = "string";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
}

export class FilterLogsBo
{
FromDate:string=null;
ToDate:string=null;
LogsStatus:string=null;
authDetailImportStatus : string ;
}